import { render, staticRenderFns } from "./AjusteParametros.vue?vue&type=template&id=0f06f24d&"
import script from "./AjusteParametros.vue?vue&type=script&lang=js&"
export * from "./AjusteParametros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports